"use strict";

var _interopRequireDefault = require("/Users/vagrant/git/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildDate = buildDate;
exports.getDayOptions = getDayOptions;
exports.getMaxDay = getMaxDay;
exports.getYearOptions = getYearOptions;
exports.normalizeDateDay = normalizeDateDay;
exports.pad2 = pad2;
exports.parseDateString = parseDateString;
exports.validateDateParts = validateDateParts;
require("core-js/modules/es6.regexp.split");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.array.from");
var _objectSpread2 = _interopRequireDefault(require("/Users/vagrant/git/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
require("core-js/modules/es6.number.constructor");
require("core-js/modules/es7.string.pad-start");
function pad2(val) {
  return String(val).padStart(2, '0');
}
function getMaxDay(year, month) {
  if (!month) return 31;
  if (year && month) {
    return new Date(Number(year), Number(month), 0).getDate();
  }
  var m = Number(month);
  if ([4, 6, 9, 11].includes(m)) return 30;
  if (m === 2) return 29;
  return 31;
}
function validateDateParts(parts) {
  var isRequired = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var year = parts.year,
    month = parts.month,
    day = parts.day;
  if (!year && !month && !day) {
    return isRequired ? '日付を入力してください。' : '';
  }
  if (year && !month && !day) {
    return '';
  }
  if (year && month && !day) {
    return '';
  }
  if (year && month && day) {
    var maxDay = new Date(Number(year), Number(month), 0).getDate();
    if (Number(day) > maxDay) {
      return '日付の形式が正しくありません。';
    }
    return '';
  }
  if (year && !month && day) {
    return '年と日だけを入力することはできません。月を入力してください。';
  }
  if (!year && month && day) {
    return '月と日だけを入力することはできません。年を入力してください。';
  }
  return '日付の形式が正しくありません。';
}
function normalizeDateDay(parts) {
  var year = parts.year,
    month = parts.month,
    day = parts.day;
  if (!day) {
    return (0, _objectSpread2.default)({}, parts);
  }
  if (!month) {
    return (0, _objectSpread2.default)({}, parts);
  }
  var maxDay = getMaxDay(year, month);
  if (Number(day) > maxDay) {
    return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, parts), {}, {
      day: ''
    });
  }
  return (0, _objectSpread2.default)({}, parts);
}
function buildDate(parts) {
  var year = parts.year,
    month = parts.month,
    day = parts.day;
  var y = year || '';
  var m = month ? pad2(month) : '';
  var d = day ? pad2(day) : '';
  if (!y && !m && !d) {
    return '';
  }
  if (y && !m && !d) {
    return y;
  }
  if (!y && m && !d) {
    return "-".concat(m, "-");
  }
  if (!y && !m && d) {
    return "--".concat(d);
  }
  if (y && m && !d) {
    return "".concat(y, "-").concat(m);
  }
  if (y && !m && d) {
    return "".concat(y, "--").concat(d);
  }
  if (!y && m && d) {
    return "-".concat(m, "-").concat(d);
  }
  if (y && m && d) {
    return "".concat(y, "-").concat(m, "-").concat(d);
  }
  return '';
}
function getYearOptions() {
  var startYear = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1950;
  var currentYear = new Date().getFullYear();
  var years = [];
  for (var y = currentYear; y >= startYear; y--) {
    years.push(y);
  }
  return years;
}
function getDayOptions(parts) {
  var year = parts.year,
    month = parts.month;
  var maxDay = getMaxDay(year, month);
  return Array.from({
    length: maxDay
  }, function (_, i) {
    return i + 1;
  });
}
function parseDateString(dateStr) {
  var arr = String(dateStr || '').split('-');
  return {
    year: arr[0] || '',
    month: arr[1] || '',
    day: arr[2] || ''
  };
}